import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {Card, Grid, Icon, Popup} from 'semantic-ui-react';
import {partClassification} from '../../../../common/dictionaries/classification';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {paths} from '../../../../common/dictionaries/urls';
import StockTde from './section/stockTDE';
import Stock from './section/stock';
import OnOrders from './section/onOrders';
import BackOrders from './section/backOrders';
import Sustitute from './section/sustitute';
import Models from './section/models';
import './viewCpdQuery.scss';

class ViewCpdQuery extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.Queries,
        scopes.See
      )
    ) {
      this.props.push(paths.AccessDenied);
      return;
    }

    const {code} = this.props;
    this.props.fetchPart(code);
  }

  componentDidUpdate(prevProps) {
    const {code} = this.props;
    if (code !== prevProps.code) {
      this.props.fetchPart(code);
    }
  }

  onCancelClick() {
    this.props.goBack();
  }

  renderAlertIcon(iconName, color) {
    return <Icon link name={iconName} color={color} size='large' />;
  }

  renderAlert() {
    const {data} = this.props;
    const stockDeviation = data.stockDeviation;
    const stockUpperLimit = data.acceptedDeviation;
    const stockLowerLimit = data.acceptedDeviation * -1;

    if (!stockDeviation || !stockUpperLimit) {
      return null;
    }
    const isStockIntoAcceptedDesviation =
      stockDeviation >= stockLowerLimit && stockDeviation <= stockUpperLimit;
    if (isStockIntoAcceptedDesviation) {
      return this.renderAlertIcon('check circle', 'green');
    }
    return this.renderAlertIcon('close circle', 'red');
  }

  renderTooltipAlert() {
    const {data} = this.props;
    const stockDeviation = data.stockDeviation;
    const stockUpperLimit = data.acceptedDeviation;
    const stockLowerLimit = data.acceptedDeviation * -1;

    if (!stockDeviation || !stockUpperLimit) {
      return null;
    }
    const isStockIntoAcceptedDesviation =
      stockDeviation >= stockLowerLimit && stockDeviation <= stockUpperLimit;
    const message = `La desviación del stock estándar (${stockDeviation}%) ${
      isStockIntoAcceptedDesviation ? '' : 'no'
    }
    se encuentra en el rango (${stockLowerLimit}%, ${stockUpperLimit}%).`;
    return <p>{message}</p>;
  }

  getMoneyValue(value = 0) {
    return `$${getNumericValue(value, 2)}`;
  }

  renderPriceSection() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PartPrices,
        scopes.See
      )
    ) {
      return null;
    }
    const {data} = this.props;
    return (
      <Grid.Column width={5}>
        <Grid columns={4}>
          <Grid.Row>
            <Grid.Column width={3} textAlign='left' className='label'>
              Costo
            </Grid.Column>
            <Grid.Column width={4} textAlign='right'>
              {this.getMoneyValue(data.cost)}
            </Grid.Column>
            <Grid.Column width={5} textAlign='right' className='label'>
              Wholesale
            </Grid.Column>
            <Grid.Column width={3} textAlign='right'>
              {this.getMoneyValue(data.pvpToyotaEcuador)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} textAlign='left' className='label'>
              Retail
            </Grid.Column>
            <Grid.Column width={4} textAlign='right'>
              {this.getMoneyValue(data.pvp)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    );
  }

  render() {
    const {code, data, push} = this.props;

    return (
      <div className='view-cpd-query'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick.bind(this)} />
              <h2>
                {code} | {data.name}
              </h2>
            </div>
            <div className='subtitle'>
              {data.franchise} | {partClassification[data.classification]} |{' '}
              {data.origin}
            </div>
            <div className='description'>
              <Grid divided>
                <Grid.Row stretched>
                  <Grid.Column width={1}>
                    <Grid columns={1}>
                      <Grid.Row>
                        <Grid.Column className='label'>ICC</Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column>{data.salesIcc}</Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Grid columns={2} textAlign='left'>
                      <Grid.Row>
                        <Grid.Column width={9} className='label'>
                          Ubicación Actual
                        </Grid.Column>
                        <Grid.Column width={7} className='bigger-label'>
                          {data.currentLocation}
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column width={9} className='label'>
                          Ubicación Anterior
                        </Grid.Column>
                        <Grid.Column width={7}>
                          {data.previousLocation}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Grid columns={4}>
                      <Grid.Row>
                        <Grid.Column
                          width={4}
                          textAlign='left'
                          className='label'
                        >
                          MAD Pedido
                        </Grid.Column>
                        <Grid.Column width={3} textAlign='right'>
                          {getNumericValue(data.ordersMad, 2)}
                        </Grid.Column>
                        <Grid.Column
                          width={6}
                          textAlign='left'
                          className='label'
                        >
                          MIP
                        </Grid.Column>
                        <Grid.Column width={3} textAlign='right'>
                          {getNumericValue(data.salesMip, 2)}
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column
                          width={4}
                          textAlign='left'
                          className='label'
                        >
                          MAD Venta
                        </Grid.Column>
                        <Grid.Column width={3} textAlign='right'>
                          {getNumericValue(data.salesMad, 2)}
                        </Grid.Column>
                        <Grid.Column
                          width={6}
                          textAlign='left'
                          className='label'
                        >
                          Stock Estándar
                          <Popup
                            trigger={
                              <span className='margin-left'>
                                {this.renderAlert()}
                              </span>
                            }
                            content={this.renderTooltipAlert()}
                            position='top center'
                            inverted
                          />
                        </Grid.Column>
                        <Grid.Column width={3} textAlign='right'>
                          {getNumericValue(data.standardStock, 2)}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>

                  {this.renderPriceSection()}
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        <div className='primary-content'>
          <Card raised fluid>
            <StockTde code={code} />
          </Card>

          <Grid>
            <Grid.Column width={10}>
              <Card raised fluid>
                <Stock code={code} />
              </Card>
            </Grid.Column>
            <Grid.Column width={6}>
              <Card raised fluid>
                <OnOrders code={code} />
              </Card>
            </Grid.Column>
          </Grid>

          <Card raised fluid>
            <BackOrders code={code} />
          </Card>

          <Grid>
            <Grid.Column width={4}>
              <Card raised fluid>
                <Sustitute push={push} />
              </Card>
            </Grid.Column>
            <Grid.Column width={12}>
              <Card raised fluid>
                <Models code={code} />
              </Card>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {code} = ownProps.params;
  return {
    code,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
    'data': state.parts.partData,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {fetchPart, withRouter} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    fetchPart,
  })(ViewCpdQuery)
);
